module.exports = __webpack_public_path__ + "img/share.04720fc0.png";